import { render, staticRenderFns } from "./FamilyTab.vue?vue&type=template&id=56e7f23d&scoped=true"
import script from "./FamilyTab.vue?vue&type=script&lang=js"
export * from "./FamilyTab.vue?vue&type=script&lang=js"
import style0 from "./FamilyTab.vue?vue&type=style&index=0&id=56e7f23d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7f23d",
  null
  
)

export default component.exports